import * as Yup from 'yup';

import { VALIDATIONS_ERROR } from '~constants/validationsError';

export const FIELDS_NAME = {
  COMPANY_NAME: 'companyName',
  EMAIL: 'email',
  CONTACT_PHONE: 'contactPhone',
} as const;

export const initialValues = {
  [FIELDS_NAME.COMPANY_NAME]: '',
  [FIELDS_NAME.EMAIL]: '',
  [FIELDS_NAME.CONTACT_PHONE]: '',
};

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.COMPANY_NAME]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.EMAIL]: Yup.string()
    .email(VALIDATIONS_ERROR.EMAIL)
    .required(VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.CONTACT_PHONE]: Yup.string().notRequired(),
});
